import { BwFileMagnifyingGlass } from "@/components/ui/icons";
import type { LightBoxAttachment } from "@/components/ui/lightbox/light-box-attachment";
import UnsupportedPreviewAttachment from "@/components/ui/lightbox/unsupported-preview-attachment";
import { getDownloadUrl } from "@/components/ui/lightbox/utils";

type UnsupportedPreviewCardProps<TAttachment extends LightBoxAttachment> = {
  item: TAttachment;
};

const UnsupportedPreviewCard = <TAttachment extends LightBoxAttachment>(
  props: UnsupportedPreviewCardProps<TAttachment>,
) => {
  const { item } = props;

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center max-w-full px-4 py-6 w-98 bg-bg-dark-max/40 backdrop-blur-2xl rounded-2xl">
        <BwFileMagnifyingGlass size={96} />
        <h3 className="mt-4 font-semibold text-text-light">Couldn't preview</h3>
        <p className="mt-1 text-text-light/64">
          The file is unsupported. Try to download it to your local workstation
          and open it in another application.
        </p>
        <UnsupportedPreviewAttachment
          fileName={item.fileName ?? ""}
          fileSize={item.fileSize ?? 0}
          href={getDownloadUrl(item.contentUri as string)}
        />
      </div>
    </div>
  );
};

export default UnsupportedPreviewCard;
